import React from 'react';
import { Alert, Image, type ViewStyle } from 'react-native';
import type { CompetitionProps, CompetitionSummaryProps } from '../../types';
import { useColors } from '../../constants/useColors';
import { Button, Text, View } from '../../Components/Themed';

type CompetitionHeaderProps = {
    action_loading:boolean,
    competition:CompetitionProps,
    header_style?:ViewStyle,
    competition_summaries:CompetitionSummaryProps[],
    competition_valid: {
        valid:boolean,
        info:boolean,
        contests:boolean,
        contest_settings: boolean,
        settings:boolean
    },
    onPause:() => void,
    onResume: () => void,
    onDelete:() => void,
    onActivate: () => void
}

const CompetitionHeader = ({ header_style, action_loading, competition_summaries, competition, competition_valid, onDelete, onActivate, onPause, onResume }:CompetitionHeaderProps) => {
    const Colors = useColors();
    const handleActivate = () => {
        if(!competition_valid.valid){
            return alert(`Please complete all the required sections before activating`)
        }
        onActivate()
    }

    const handleResume = () => {
        if(!competition_valid.valid){
            return alert(`Please complete all the required sections before activating`)
        }
        onResume()
    }
    
    return (
        <View transparent>
            <View nativeID="competition_header" style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderColor:Colors.borders.light, ...header_style }}>
                <View>
                    <Image
                        source={{ uri: competition.image?.url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1649737862/be_logo_jte2ux.webp' }}
                        style={{ height:50, width:50, borderRadius:4 }}
                        resizeMode="cover"
                    />
                </View>
                <View style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{competition.competition_name}</Text>
                    <Text style={{ marginTop:4 }} theme='h2'>{competition.competition_description}</Text>
                </View>
                {competition.status == 'pending'?
                <Button
                    title={'ACTIVATE'}
                    style={{ opacity:competition_valid.valid ? 1: 0.5 }}
                    loading={action_loading}
                    type='success'
                    onPress={() => handleActivate()}
                />
                :<></>}
            </View>
            {competition.status == 'pending' ? 
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>COMPETITION IS PENDING</Text>
                    <Text style={{ marginTop:3 }} theme='description'>Complete each section and press 'ACTIVATE'.</Text>
                </View>
                <Button
                    title='DELETE'
                    style={{ opacity:!action_loading? 1: 0.5 }}
                    loading={action_loading}
                    type='error'
                    onPress={async() => {
                        Alert.alert('Are you sure you would like to delete?', 'This cannot be undone', [
                            {
                                text:'Cancel',
                                onPress:() => console.log('hey')
                            },
                            {
                                text: `Yes I'm Sure`,
                                onPress:() => onDelete()
                            }
                        ])
                    }}
                />
            </View>
            :<></>}
            {competition.status == 'scheduled' ?
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>COMPETITION IS ACTIVE</Text>
                    <Text style={{ marginTop:3 }} theme='description'>In order to edit this competition, you must first pause it.</Text>
                </View>
                <Button
                    title='PAUSE'
                    style={{ opacity:!action_loading && competition_valid.valid ? 1: 0.5 }}
                    loading={action_loading}
                    type='success'
                    onPress={() => onPause()}
                />
            </View>
            :<></>}
            {competition.status == 'paused' ?
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>EDITING COMPETITION</Text>
                    <Text style={{ marginTop:3 }} theme='description'>Feel free to make changes. When done, simply press resume.</Text>
                </View>
                {competition_summaries.length == 0 ?
                <Button
                    title='DELETE'
                    style={{ marginRight:5, opacity:!action_loading ? 1: 0.5 }}
                    loading={action_loading}
                    type='error'
                    onPress={async() => {
                        Alert.alert('Are you sure you would like to delete?', 'This cannot be undone', [
                            {
                                text:'Cancel',
                                onPress:() => console.log('hey')
                            },
                            {
                                text: `Yes I'm Sure`,
                                onPress:() => onDelete()
                            }
                        ])
                    }}
                />
                :<></>}
                <Button
                    title='RESUME'
                    style={{ opacity:!action_loading && competition_valid.valid ? 1: 0.5 }}
                    loading={action_loading}
                    type='success'
                    onPress={() => handleResume()}
                />
            </View>
            :<></>}
        </View>
    )
}

export default CompetitionHeader